export default {
  SAVE_GROUP_FOR_NEXT_LOT: 'createLot/SAVE_GROUP_FOR_NEXT_LOT',
  SAVE_REFUND_POLICY_FOR_NEXT_LOT: 'createLot/SAVE_REFUND_POLICY_FOR_NEXT_LOT',
};
